import { LEVEL, MESSAGE } from 'triple-beam';
import { format } from 'winston';
import { messageSymbol } from '../utils.js';
import { redactObject } from './redactObject/redactObject.js';

/**
 * Global Keys that should be redacted.
 *
 * Please make sure to add new keys in alphabetical order.
 */ const KEYS = [
    'accessToken',
    'accountNumber',
    'address',
    'addressTag',
    'advanceNumber',
    'authorizedEmail',
    'bankAddress',
    'bankName',
    'billingDetails',
    'businessCountry',
    'businessEntityName',
    'businessState',
    'businessWebsite',
    'city',
    'country',
    'description',
    'district',
    'email',
    'entityAccountNumber',
    'entitySecret',
    'entitySecretCiphertext',
    'fiatAccountId',
    'fingerprint',
    'fromAddress',
    'iban',
    'institutionCode',
    'invoiceNumber',
    'line1',
    'line2',
    'newPassword',
    'nonAuthorizedEmail',
    'oldPassword',
    'password',
    'postalCode',
    'privateKey',
    'routingNumber',
    'secret',
    'stateToken',
    'swiftCode',
    'transactionHash',
    'transitNumber',
    'userEmail',
    'walletAddress',
    'wireBankAccountId'
];
/**
 * Creates a Winston logger format function that redacts sensitive data
 * from log messages.
 * @returns A Winston format function that redacts sensitive data from log messages.
 */ const redact = (keysToRedact = [])=>format((info)=>{
        // redact sensitive data using the redactObject function
        const redactInfo = redactObject(info, [
            ...KEYS,
            ...keysToRedact
        ]);
        // backfill the symbol fields required by winston
        // winston internal fields reference:
        // https://github.com/winstonjs/logform?tab=readme-ov-file#info-objects
        // how winston console transport uses the internal fields when writing the logs:
        // https://github.com/winstonjs/winston/blob/master/lib/winston/transports/console.js#L48-L55
        redactInfo[LEVEL] = redactInfo.level;
        redactInfo[MESSAGE] = messageSymbol(redactInfo);
        return redactInfo;
    });

export { redact };
//# sourceMappingURL=redact.js.map
